document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    var cookieBanner = document.querySelector('.cookie-banner');
    
    if (cookieBanner) {
      cookieBanner.classList.add('is-active2');
    }
  }, 1000);
  setTimeout(function() {
    var cookieBanner = document.querySelector('.cookie-banner');
    
    if (cookieBanner) {
      cookieBanner.classList.remove('is-active2');
    }
  }, 8000); // 8 seconds

  var stickyATC = document.querySelector('.sticky-cart .product-form__submit.button');
  stickyATC.disabled = true;
  setTimeout(function() {
    var stickyATC = document.querySelector('.sticky-cart .product-form__submit.button');
    stickyATC.disabled = false;
    var stickyATCForm = document.querySelector('.sticky-cart .shopify-product-form');
    const button = document.querySelector('.customily-personalize-button');
    
    if (button) {
      stickyATC.addEventListener('click', function(e) {
        e.preventDefault();
        button.click();
      });
      const buttonText = button.textContent;
      stickyATC.textContent = buttonText;

      const observer = new MutationObserver((mutations) => {
        // Limit the observer function execution frequency
        const now = performance.now();
        const minExecutionInterval = 200; // Minimum time between executions in milliseconds
        if (!window.lastExecutionTime || now - window.lastExecutionTime > minExecutionInterval) {
          window.lastExecutionTime = now;
      
          mutations.forEach((mutation) => {
            if (mutation.type === 'characterData' || mutation.type === 'childList') {
              stickyATC.textContent = buttonText;
            }
          });
        }
      });
      
      observer.observe(stickyATC, {
        characterData: true,
        childList: true,
        subtree: true,
      });
    }
  }, 5000);
});












